var map = {
	"./de-DE/dataset-creation": 91755,
	"./en-US/dataset-creation": 37342,
	"./es-ES/dataset-creation": 25333,
	"./fa-IR/dataset-creation": 29885,
	"./fr-FR/dataset-creation": 84817,
	"./hi-IN/dataset-creation": 79051,
	"./it-IT/dataset-creation": 65043,
	"./ja-JP/dataset-creation": 91726,
	"./ko-KR/dataset-creation": 72120,
	"./pl-PL/dataset-creation": 45173,
	"./pt-BR/dataset-creation": 15677,
	"./ro-RO/dataset-creation": 82131,
	"./ru-RU/dataset-creation": 48135,
	"./sl-SI/dataset-creation": 30230,
	"./th-TH/dataset-creation": 36589,
	"./tr-TR/dataset-creation": 85901,
	"./uk-UA/dataset-creation": 98819,
	"./vi-VN/dataset-creation": 35868,
	"./zh-Hans/dataset-creation": 60679,
	"./zh-Hant/dataset-creation": 32540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96065;